import React from "react";
import { Facebook, ArrowUpRight, Instagram } from "lucide-react";
import { ORDER_LINKS } from "../data/menu";

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-[#FF6392] text-white">
      <div className="mx-auto max-w-7xl px-4 pt-14 sm:pt-20 pb-10 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <h2 className="font-serif-display text-4xl leading-[0.95] tracking-tight text-white sm:text-7xl lg:text-8xl">
              Stay sweet,
              <br />
              <span className="italic text-[#FFE3EB]">McAllen.</span>
            </h2>
            <p className="mt-6 max-w-md text-base sm:text-lg text-white/90">
              Follow along for new flavors, weekend specials, and behind-the-glaze moments.
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href={ORDER_LINKS.facebook}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="inline-flex w-full sm:w-auto justify-center items-center gap-2 rounded-full bg-white px-5 py-2.5 font-semibold text-[#2D2327] transition-colors hover:bg-[#2D2327] hover:text-white"
              >
                <Facebook className="h-4 w-4" /> Facebook
              </a>
              <a
                href={ORDER_LINKS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="inline-flex w-full sm:w-auto justify-center items-center gap-2 rounded-full border-2 border-white bg-white/0 px-5 py-2.5 font-semibold text-white transition-colors hover:bg-white hover:text-[#FF6392]"
              >
                <Instagram className="h-4 w-4" /> @dondonutsrgv
              </a>
            </div>
          </div>

          <div className="grid gap-8 text-white/90 sm:grid-cols-2 lg:col-span-5">
            <div>
              <div className="mb-3 text-xs uppercase tracking-[0.22em] text-[#FFE3EB]">Menu</div>
              <ul className="space-y-2">
                <li><a className="hover:text-white" href="#menu">Donuts</a></li>
                <li><a className="hover:text-white" href="#boxes">Boxes</a></li>
                <li><a className="hover:text-white" href="#drinks">Drinks</a></li>
                <li><a className="hover:text-white" href="#story">Our Story</a></li>
              </ul>
            </div>
            <div>
              <div className="mb-3 text-xs uppercase tracking-[0.22em] text-[#FFE3EB]">Order</div>
              <ul className="space-y-2">
                <li><a className="inline-flex items-center gap-1 hover:text-white" target="_blank" rel="noreferrer" href={ORDER_LINKS.doordash}>DoorDash <ArrowUpRight className="h-3 w-3" /></a></li>
                <li><a className="inline-flex items-center gap-1 hover:text-white" target="_blank" rel="noreferrer" href={ORDER_LINKS.grubhub}>Grubhub <ArrowUpRight className="h-3 w-3" /></a></li>
                <li><a className="inline-flex items-center gap-1 hover:text-white" target="_blank" rel="noreferrer" href={ORDER_LINKS.orderOnline}>Order.Online <ArrowUpRight className="h-3 w-3" /></a></li>
                <li><a className="hover:text-white" href={ORDER_LINKS.phone}>(956) 502-7221</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/20 pt-6 text-xs sm:text-sm text-white/80 sm:flex-row sm:items-center sm:justify-between">
          <div>&copy; {new Date().getFullYear()} Don Donuts · 101 E Expressway 83, McAllen, TX · 1208 N Raul Longoria Rd, San Juan, TX</div>
          <div className="font-script text-2xl">Powered by Konticode</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
